/* Tegriware homepage: demo video dialog, product card color selection, cart drawer add. No dependencies. */
(function () {
  if (window.__twhInit) return;
  window.__twhInit = true;

  /* ---------- Demo video dialog ---------- */
  var dialog;
  function ytId(src) {
    var m = String(src || '').match(/(?:youtu\.be\/|v=|embed\/|shorts\/)([A-Za-z0-9_-]{6,})/);
    return m ? m[1] : null;
  }
  function closeVideo() {
    if (!dialog) return;
    dialog.querySelector('.twh-dialog__frame').innerHTML = '';
    if (dialog.open) dialog.close();
  }
  function openVideo(btn) {
    var src = btn.getAttribute('data-twh-video');
    if (!src) return;
    if (!dialog) {
      dialog = document.createElement('dialog');
      dialog.className = 'twh twh-dialog';
      dialog.setAttribute('aria-label', 'SwivelServe demo video');
      dialog.innerHTML = '<div class="twh-dialog__in"><div class="twh-dialog__bar"><span class="twh-dialog__title"></span><button type="button" aria-label="Close video"><svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18"/></svg></button></div><div class="twh-dialog__frame"></div></div>';
      document.body.appendChild(dialog);
      dialog.querySelector('button').addEventListener('click', closeVideo);
      dialog.addEventListener('click', function (e) { if (e.target === dialog) closeVideo(); });
      dialog.addEventListener('close', function () { dialog.querySelector('.twh-dialog__frame').innerHTML = ''; });
    }
    dialog.querySelector('.twh-dialog__title').textContent = btn.getAttribute('data-twh-video-title') || 'Watch it work';
    var frame = dialog.querySelector('.twh-dialog__frame');
    var id = ytId(src);
    if (id) {
      frame.innerHTML = '<iframe src="https://www.youtube-nocookie.com/embed/' + id + '?autoplay=1&rel=0&modestbranding=1&playsinline=1" title="SwivelServe demo video" allow="autoplay; encrypted-media; picture-in-picture; fullscreen" allowfullscreen></iframe>';
    } else {
      frame.innerHTML = '<video src="' + src.replace(/"/g, '&quot;') + '" controls autoplay playsinline></video>';
    }
    if (typeof dialog.showModal === 'function') dialog.showModal(); else window.open(src, '_blank', 'noopener');
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-twh-video]');
    if (btn) { e.preventDefault(); openVideo(btn); }
  });

  /* ---------- Product cards ---------- */
  function initCard(card) {
    if (card.__twh) return;
    card.__twh = true;
    var dataEl = card.querySelector('[data-twh-options]');
    if (!dataEl) return;
    var opts;
    try { opts = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var idInput = card.querySelector('input[name="id"]');
    var priceEl = card.querySelector('[data-twh-price]');
    var compareEl = card.querySelector('[data-twh-compare]');
    var img = card.querySelector('.twh-pic img');
    var links = card.querySelectorAll('[data-twh-link]');
    var btn = card.querySelector('[data-twh-atc]');
    var chosen = card.querySelector('[data-twh-chosen]');
    card.addEventListener('change', function (e) {
      if (!e.target.matches('[data-twh-opt]')) return;
      var o = opts[+e.target.value];
      if (!o) return;
      if (idInput) idInput.value = o.id;
      if (priceEl) priceEl.textContent = o.price;
      if (compareEl) { compareEl.textContent = o.compare || ''; compareEl.hidden = !o.compare; }
      if (img && o.img) { img.src = o.img; img.removeAttribute('srcset'); img.alt = o.alt || img.alt; }
      links.forEach(function (a) { if (o.url) a.href = o.url; });
      if (chosen) chosen.textContent = o.label;
      if (btn) {
        btn.disabled = !o.available;
        btn.textContent = o.available ? btn.getAttribute('data-label') : btn.getAttribute('data-sold');
      }
    });
  }

  /* ---------- Add to cart: use the theme cart drawer when one is available ---------- */
  function drawerTarget() {
    var d = document.querySelector('cart-drawer');
    if (d && typeof d.renderContents === 'function' && typeof d.getSectionsToRender === 'function') return d;
    return null;
  }
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.closest || !form.closest('[data-twh-card]') || !window.fetch || !window.FormData) return;
    var drawer = drawerTarget();
    if (!drawer) return; /* Otherwise the theme's own product-form handles it */
    e.preventDefault();
    var btn = form.querySelector('[data-twh-atc]');
    if (btn) btn.setAttribute('aria-busy', 'true');
    var fd = new FormData(form);
    if (!fd.get('quantity')) fd.set('quantity', '1');
    fd.set('sections', (drawer.getSectionsToRender() || []).map(function (x) { return x.section; }).join(','));
    fd.append('sections_url', window.location.pathname);
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    fetch(root + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: fd })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok || res.j.status) throw new Error(res.j.description || res.j.message || 'Could not add to cart');
        drawer.renderContents(res.j);
        document.dispatchEvent(new CustomEvent('twh:cart:added', { detail: res.j }));
      })
      .catch(function () { form.submit(); })
      .finally(function () { if (btn) btn.removeAttribute('aria-busy'); });
  });

  function init(root) {
    (root || document).querySelectorAll('[data-twh-card]').forEach(initCard);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
